/* RESILIENT1 — Theme JS: scroll reveal, header state, mobile nav, PDP thumbs */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initMobileNav();
    initReveal();
    initPdpThumbs();
    initPdpSwatches();
  });

  function initHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function initMobileNav() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("is-open");
      });
    });
  }

  function initReveal() {
    var targets = document.querySelectorAll("[data-reveal]");
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (t) { t.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            var children = entry.target.querySelectorAll("[data-reveal-child]");
            children.forEach(function (child, i) {
              setTimeout(function () {
                child.classList.add("is-visible");
              }, i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    targets.forEach(function (t) { observer.observe(t); });
  }

  function initPdpThumbs() {
    var thumbs = document.querySelectorAll("[data-thumb]");
    var mainImg = document.getElementById("rz-pdp-main-img");
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        mainImg.src = btn.getAttribute("data-src");
      });
    });
  }

  function initPdpSwatches() {
    var swatches = document.querySelectorAll(".rz-pdp__swatch");
    swatches.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest(".rz-pdp__swatches");
        if (group) {
          group.querySelectorAll(".rz-pdp__swatch").forEach(function (b) {
            b.classList.remove("is-active");
          });
        }
        btn.classList.add("is-active");
      });
    });
  }
})();
